export default "__VITE_ASSET__3459ed58__"